export const COLABFOLD_TEST_SEQUENCES = {
  test1: {
    sequence: 'MASNNTASIAQARKLVEQLKMEANIDRIKVSKAAADLMAYCEAHAKEDPLLTPVPASENPFREKKFFCAIL',
    params: {
      num_relax: 1,
      template_mode: 'pdb100' as const
    }
  },
  test2: {
    sequence: 'QLGAIENGLESGSANACPDAILIFARGSTEPGNMGITVGPALANGLESHIRNIWIQGVGGPYDAALATNFLPRGTSQANIDEGKRLFALANQKCPNTPVVAGGYSQGAALIAAAVSELSGAVKEQVKGVALFGYTQNLQNRGGIPNYPRERTKVFCNVGDAVCTGTLIITPAHLSYTIEARGEAARFLRDRIRA',
    params: {
      num_relax: 1,
      template_mode: 'pdb100' as const
    }
  }
};

export const RF_DIFFUSION_TEST_SEQUENCES = {
  test1: {
    sequence: 'MASNNTASIAQARKLVEQLKMEANIDRIKVSKAAADLMAYCEAHAKEDPLLTPVPASENPFREKKFFCAIL',
    params: {
      contigs: 'A1-70',
      num_designs: 1,
      design_mode: 'general' as const,
      symmetry: {
        type: 'cyclic' as const,
        order: 2
      }
    }
  },
  test2: {
    sequence: '',
    params: {
      contigs: 'A1-100',
      num_designs: 1,
      design_mode: 'general' as const,
      symmetry: {}
    }
  },
  binder: {
    // Example PDB structure should be loaded as the input_pdb
    sequence: `ATOM      1  N   MET A   1      27.340  24.430   2.614  1.00  9.67           N
ATOM      2  CA  MET A   1      26.266  25.413   2.842  1.00 10.38           C
ATOM      3  C   MET A   1      26.913  26.639   3.531  1.00  9.62           C
ATOM      4  O   MET A   1      27.886  26.463   4.263  1.00  9.62           O
ATOM      5  CB  MET A   1      25.112  24.880   3.649  1.00 13.77           C
ATOM      6  CG  MET A   1      25.353  24.860   5.134  1.00 16.29           C
ATOM      7  SD  MET A   1      23.930  24.292   6.097  1.00 17.17           S
ATOM      8  CE  MET A   1      24.447  24.741   7.788  1.00 16.11           C`,
    params: {
      contigs: 'A1-50/A100-200',  // Target chain A + a 100 residue binder with chain ID A
      num_designs: 2,
      design_mode: 'binder' as const,
      binder_design: true,
      hotspots: 'A30,A33,A34',
      noise_scale: 0.5,
      model_type: 'default' as const,
      binding_pocket: {
        chain: 'A',
        start: 1,
        end: 50
      },
      binder_length_min: 80,
      binder_length_max: 120
    }
  }
};

export const ESMIF_TEST_SEQUENCES = {
  test1: {
    pdb: `ATOM      1  N   MET A   1      27.340  24.430   2.614  1.00  9.67           N
ATOM      2  CA  MET A   1      26.266  25.413   2.842  1.00 10.38           C
ATOM      3  C   MET A   1      26.913  26.639   3.531  1.00  9.62           C
ATOM      4  O   MET A   1      27.886  26.463   4.263  1.00  9.62           O
ATOM      5  CB  MET A   1      25.112  24.880   3.649  1.00 13.77           C
ATOM      6  CG  MET A   1      25.353  24.860   5.134  1.00 16.29           C
ATOM      7  SD  MET A   1      23.930  24.292   6.097  1.00 17.17           S
ATOM      8  CE  MET A   1      24.447  24.741   7.788  1.00 16.11           C`,
    params: {
      num_designs: 1,
      temperature: 1.0
    }
  },
  test2: {
    pdb: `ATOM      1  N   ALA A   1      -0.677   1.230  -0.491  1.00 20.00           N
ATOM      2  CA  ALA A   1       0.000   0.000   0.000  1.00 20.00           C
ATOM      3  C   ALA A   1       1.520   0.000   0.000  1.00 20.00           C
ATOM      4  O   ALA A   1       2.200   0.908  -0.490  1.00 20.00           O
ATOM      5  CB  ALA A   1      -0.507  -1.230  -0.740  1.00 20.00           C`,
    params: {
      num_designs: 2,
      temperature: 0.8
    }
  }
}; 